module.exports = __webpack_public_path__ + "static/media/community-icon-telegram.a7a3105e.svg";